import { gql } from '@apollo/client';

export const GET_USER_BY_EMAIL_V3 = gql`
  query userByEmailV3($email: String!) {
    userByEmailV3(email: $email) {
      id
      uuid
      name
      firstName
      lastName
      email
      membershipsV2 {
        organisation
        rolesWithName {
          id
          name
        }
      }
    }
  }
`;
